import React, { Suspense } from 'react';
import { registerWorkspaceHostAuth } from '../../auth/registerWorkspaceHostAuth';

interface WorkspaceDashboardProps {
  isActive?: boolean;
}

const WorkspaceDashboardRemote = React.lazy(async () => {
  const [module] = await Promise.all([
    // @ts-expect-error kciWorkspace is a Module Federation remote defined in vite.config.ts
    import('kciWorkspace/WorkspacePage'),
    registerWorkspaceHostAuth(),
  ]);
  // WorkspacePage is a named export with no default, so the federation
  // runtime's default-interop wrapping nests the raw module under
  // `.default` instead of leaving it at the top level — check both shapes.
  const component = module.WorkspacePage ?? module.default?.WorkspacePage ?? module.default;

  if (!component) {
    throw new Error('WorkspacePage export not found in kciWorkspace/WorkspacePage');
  }

  return { default: component as React.ComponentType<WorkspaceDashboardProps> };
});

export const RemoteWorkspaceDashboard = React.memo(function RemoteWorkspaceDashboard({ isActive = true }: WorkspaceDashboardProps) {
  return (
    <Suspense fallback={<div className="body-content">Loading workspace dashboard...</div>}>
      <WorkspaceDashboardRemote isActive={isActive} />
    </Suspense>
  );
});

export default RemoteWorkspaceDashboard;